import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	buildAutomationActionLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-automation-action-label',
		defaultMessage: 'Build flow',
		description: 'Build flow action label (displayed at the footer of the card)',
	},
	buildAutomationActionLabelOld: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-automation-action-label-old',
		defaultMessage: 'Build automation',
		description: 'Build automation action label (displayed at the footer of the card)',
	},
	saveAndPublishAutomationActionLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-and-publish-automation-action-label',
		defaultMessage: 'Save and enable automation',
		description: 'Action label for saving the automation rule and enabling it',
	},
	saveAutomationActionLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-automation-action-label',
		defaultMessage: 'Save without enabling',
		description:
			'Secondary action inside the automation save/publish dropdown (saves the rule as a draft without enabling)',
	},
	saveOrPublishAutomationDropdownTriggerLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-or-publish-automation-dropdown-trigger-label',
		defaultMessage: 'More save options',
		description: 'Accessible label for the chevron button that opens the save options dropdown',
	},
	saveAutomationErrorTitle: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-automation-error-title',
		defaultMessage: "We couldn't save this automation",
		description: 'Title for the flag shown when saving a generated automation rule fails',
	},
	saveAutomationErrorDescription: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.save-automation-error-description',
		defaultMessage: 'Something went wrong while saving. Please try again.',
		description: 'Description for the flag shown when saving a generated automation rule fails',
	},
});
